import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPostcommuntiy } from '../../../actions/userActions';
import inMemoryJWT from '../../../auth/inMemoryJwt';
import MasoryPostLayout from '../../../containers/Post/MasoryPost/MasoryPost'
const ZonePost = ({match}) => {
    const zoneId = match.params.zoneId
    const dispatch = useDispatch()
    const {zonePosts,loadingZonePost} = useSelector(state=>state.userInfo)
    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }
        inMemoryJWT.waitForTokenRefresh().then(() => {

          // getUserPost(userID)
          dispatch(getUserPostcommuntiy(zoneId))
        })
        return () => {

        }
    }, [zoneId])


  

    return (
        <MasoryPostLayout  
        isLoading={loadingZonePost}
        type="profile" masoryPost={zonePosts} loadingZonePost={loadingZonePost} linkPath={`/Zones/Post/`} />
    )
};

export default ZonePost;
